import AjustesCorreo from "./ajustesCorreo";
import BajasCorreo from "./bajasCorreo";
import React, { useEffect, useMemo, useState } from "react";

import { AjustesManuales, BitacoraFila, Buzon, Candidato, ListadoBuzones, NOMBRE_ESTADO, correoApi, errorTexto, fechaHora } from "./correo.service";
import "../avisos/avisos.css";
import "./correo.css";

/**
 * Buzones (Super Admin; Esteban 2026-10-10): los buzones @washingtonacademy.com de Migadu. Crear, suspender, reactivar,
 * "Contraseña del Celular" (ver y renovar), perfil de iPhone y datos para configurar a mano. El .mx no se toca.
 */
const Buzones: React.FC = () => {
	const [d, setD] = useState<ListadoBuzones | null>(null);
	const [filtro, setFiltro] = useState<"todos" | "activo" | "suspendido" | "problema">("todos");
	const [buscar, setBuscar] = useState("");
	const [abierto, setAbierto] = useState<number | null>(null);
	const [verSin, setVerSin] = useState(false);
	const [verTodos, setVerTodos] = useState(false);
	const [edits, setEdits] = useState<Record<number, string>>({});
	const [error, setError] = useState<string | null>(null);
	const [ok, setOk] = useState<string | null>(null);
	const [ocupado, setOcupado] = useState<string | null>(null);
	const [vista, setVista] = useState<"buzones" | "bajas">("buzones");

	const cargar = () => correoApi.buzones().then((r) => setD(r.data)).catch((e) => setError(errorTexto(e)));
	useEffect(() => { cargar(); }, []);

	const hacer = async (clave: string, fn: () => Promise<any>, msg?: string) => {
		setOcupado(clave); setError(null); setOk(null);
		try { await fn(); if (msg) setOk(msg); await cargar(); } catch (e) { setError(errorTexto(e)); } finally { setOcupado(null); }
	};

	const lista = useMemo(() => {
		const q = buscar.trim().toLowerCase();
		return (d?.buzones || []).filter((b) => {
			if (filtro === "activo" && b.estado !== "activo") return false;
			if (filtro === "suspendido" && b.estado !== "suspendido") return false;
			if (filtro === "problema" && b.estado !== "error" && b.estado !== "pendiente") return false;
			return !q || ((b.nombre || "") + " " + b.email).toLowerCase().includes(q);
		});
	}, [d, filtro, buscar]);

	if (!d) return <div className="avisos-pag">{error ? <div className="av-aviso oro">{error}</div> : <div className="loader" />}</div>;
	const n = (e: string) => d.buzones.filter((b) => b.estado === e).length;
	const problemas = n("error") + n("pendiente");

	return (
		<div className="avisos-pag co">
			<div className="av-cab">
				<h1>Buzones</h1>
				<div className="av-acciones">
					<input className="av-buscar" placeholder="Buscar persona o correo…" value={buscar} onChange={(e) => setBuscar(e.target.value)} />
					<button className="av-btn" disabled={!!ocupado} onClick={() => hacer("ref", () => correoApi.refrescar(), "Estado al día con Migadu.")}>
						{ocupado === "ref" ? "Consultando…" : "Actualizar Desde Migadu"}
					</button>
					<button className="av-btn pri" onClick={() => setVerSin(!verSin)}>Crear Buzón{d.candidatos.length ? " (" + d.candidatos.length + ")" : ""}</button>
				</div>
			</div>
			<div className="av-chips co-chips" role="tablist">
				<button role="tab" aria-selected={vista === "buzones"} className={vista === "buzones" ? "on" : ""} onClick={() => setVista("buzones")}>Buzones</button>
				<button role="tab" aria-selected={vista === "bajas"} className={vista === "bajas" ? "on" : ""} onClick={() => setVista("bajas")}>Correo de Bajas</button>
			</div>
			{vista === "bajas" ? <BajasCorreo /> : <>
			{!d.configurado ? <div className="av-aviso oro">Falta la llave de Migadu en el servidor (MIGADU_USER y MIGADU_API_KEY).</div> : null}
			{d.solo_pruebas ? <div className="av-aviso oro">Candado de pruebas encendido: Migadu solo acepta direcciones prueba-…</div> : null}
			{!d.automatico ? <div className="av-tenue co-nota">Los buzones no siguen solos a las altas y bajas de personal todavía (se enciende en la mudanza). Mientras, se crean y suspenden desde aquí.</div> : null}
			{error ? <div className="av-aviso oro" onClick={() => setError(null)}>{error}</div> : null}
			{ok ? <div className="av-aviso ok" onClick={() => setOk(null)}>{ok}</div> : null}

			<div className="av-chips co-chips">
				{([["todos", "Todos", d.buzones.length], ["activo", "Activos", n("activo")], ["suspendido", "Suspendidos", n("suspendido")], ["problema", "Con Problema", problemas]] as const).map(([k, t, c]) => (
					<button key={k} className={filtro === k ? "on" : ""} onClick={() => setFiltro(k)}>{t} <i>{c}</i></button>
				))}
			</div>

			{verSin ? (
				<section className="co-tarjeta">
					<div className="avk-bloque-cab">
						<h3>Personal Sin Buzón</h3>
						<span className="co-acc-cab">
							{d.candidatos.length > 1 ? <button className="av-btn chico pri" disabled={!!ocupado} onClick={() => { setVerTodos(true); setVerSin(false); }}>Crear Todos los Pendientes</button> : null}
							<button className="av-x grande" onClick={() => setVerSin(false)} aria-label="Cerrar">×</button>
						</span>
					</div>
					{d.candidatos.length === 0 ? <div className="av-tenue">Todo el personal activo ya tiene buzón.</div> : (
						<ul className="co-filas">
							{d.candidatos.map((c) => {
								const dir = dirDe(c, edits);
								return (
									<li key={c.user_id} className="co-fila co-cand">
										<span className="co-nom"><b>{c.nombre}</b><small>{c.roles || ""}{c.nota ? (c.roles ? " · " : "") + c.nota : ""}</small></span>
										{c.revisar ? <em className="co-chip oro">Revisar</em> : null}
										<CampoDireccion valor={dir} dominio={d.dominio} onChange={(v) => setEdits({ ...edits, [c.user_id]: v })} />
										<button className="av-btn chico pri" disabled={!!ocupado || !dir} onClick={() => hacer("c" + c.user_id, () => correoApi.crear(c.user_id, dir + "@" + d.dominio), "Buzón creado: " + dir + "@" + d.dominio)}>
											{ocupado === "c" + c.user_id ? "Creando…" : "Crear"}
										</button>
									</li>
								);
							})}
						</ul>
					)}
				</section>
			) : null}

			{verTodos ? <CrearTodos d={d} edits={edits} setEdits={setEdits} cerrar={() => setVerTodos(false)} alTerminar={cargar} /> : null}

			{lista.length === 0 ? <div className="av-vacio">No hay buzones con ese filtro.</div> : (
				<ul className="co-filas co-lista">
					{lista.map((b) => (
						<li key={b.id} className={"co-bloque" + (abierto === b.id ? " abierto" : "")}>
							<button className="co-fila co-cab" onClick={() => setAbierto(abierto === b.id ? null : b.id)}>
								<span className="co-nom"><b>{b.nombre || b.email}</b><small>{b.email}{b.roles ? " · " + b.roles : ""}</small></span>
								{b.uso_mb !== null ? <span className="co-uso av-tenue">{b.uso_mb} MB</span> : null}
								<em className={"co-chip " + b.estado}>{NOMBRE_ESTADO[b.estado] || b.estado}</em>
							</button>
							{abierto === b.id ? <Detalle b={b} ocupado={ocupado} hacer={hacer} setError={setError} /> : null}
						</li>
					))}
				</ul>
			)}
			</>}
		</div>
	);
};

/** Lo que va antes de la @ de un candidato: lo que editó la persona, o lo propuesto (si su correo de acceso se ve mal escrito, la sugerida). */
const localDe = (x: string) => x.split("@")[0];
const dirDe = (c: Candidato, edits: Record<number, string>) => (edits[c.user_id] !== undefined ? edits[c.user_id] : localDe(c.revisar && c.sugerida ? c.sugerida : c.email)).trim().toLowerCase();

const CampoDireccion: React.FC<{ valor: string; dominio: string; onChange: (v: string) => void }> = ({ valor, dominio, onChange }) => (
	<span className="co-dir">
		<input value={valor} onChange={(e) => onChange(e.target.value.replace(/[^a-zA-Z0-9._-]/g, ""))} aria-label="Dirección del buzón" maxLength={60} />
		<small>@{dominio}</small>
	</span>
);

/** "Crear Todos los Pendientes": primero el plan (se puede editar o quitar a cada quien), luego se crea de 10 en 10 con avance. */
const CrearTodos: React.FC<{ d: ListadoBuzones; edits: Record<number, string>; setEdits: (e: Record<number, string>) => void; cerrar: () => void; alTerminar: () => void }> = ({ d, edits, setEdits, cerrar, alTerminar }) => {
	const [quitados, setQuitados] = useState<Record<number, boolean>>(() => Object.fromEntries(d.candidatos.filter((c) => c.revisar).map((c) => [c.user_id, true])));
	const [fase, setFase] = useState<"plan" | "creando" | "listo">("plan");
	const [hechos, setHechos] = useState(0);
	const [fallas, setFallas] = useState<{ email: string; error: string }[]>([]);
	const elegidos = d.candidatos.filter((c) => !quitados[c.user_id]);
	const repetidas = useMemo(() => {
		const m: Record<string, number> = {};
		elegidos.forEach((c) => { const k = dirDe(c, edits); m[k] = (m[k] || 0) + 1; });
		return m;
	}, [elegidos, edits]);
	const hayMalas = elegidos.some((c) => !dirDe(c, edits) || repetidas[dirDe(c, edits)] > 1);

	const crear = async () => {
		if (!window.confirm("¿Crear " + elegidos.length + " buzones en Migadu? Cada persona recibe su contraseña del celular; su correo de acceso a WAPP no cambia.")) return;
		setFase("creando"); setHechos(0); setFallas([]);
		const lista = elegidos.map((c) => ({ user_id: c.user_id, email: dirDe(c, edits) + "@" + d.dominio }));
		for (let i = 0; i < lista.length; i += 10) {
			try {
				const r = await correoApi.crearLote(lista.slice(i, i + 10));
				setHechos((h) => h + r.data.resultados.filter((x) => x.ok).length);
				const malos = r.data.resultados.filter((x) => !x.ok).map((x) => ({ email: x.email, error: x.error || "" }));
				if (malos.length) setFallas((f) => [...f, ...malos]);
			} catch (e) {
				setFallas((f) => [...f, { email: "tanda " + (i / 10 + 1), error: errorTexto(e) }]);
			}
		}
		setFase("listo"); alTerminar();
	};

	return (
		<section className="co-tarjeta">
			<div className="avk-bloque-cab"><h3>Crear Todos los Pendientes</h3><button className="av-x grande" disabled={fase === "creando"} onClick={cerrar} aria-label="Cerrar">×</button></div>
			{fase === "plan" ? (
				<>
					<div className="av-tenue co-nota">Se crearán {elegidos.length} de {d.candidatos.length} buzones. Corrige cualquier dirección o quita a quien no deba tener. La dirección es independiente del correo con el que entran a WAPP.</div>
					<ul className="co-filas">
						{d.candidatos.map((c) => {
							const dir = dirDe(c, edits);
							const mala = !quitados[c.user_id] && (!dir || repetidas[dir] > 1);
							return (
								<li key={c.user_id} className={"co-fila co-cand" + (quitados[c.user_id] ? " quitado" : "")}>
									<input type="checkbox" checked={!quitados[c.user_id]} onChange={(e) => setQuitados({ ...quitados, [c.user_id]: !e.target.checked })} aria-label={"Crear buzón de " + c.nombre} />
									<span className="co-nom"><b>{c.nombre}</b><small>{c.roles || ""}{c.revisar ? (c.roles ? " · " : "") + "su correo de acceso se ve mal escrito" : ""}</small></span>
									{mala ? <em className="co-chip oro">{dir ? "Repetida" : "Falta"}</em> : null}
									<CampoDireccion valor={dir} dominio={d.dominio} onChange={(v) => setEdits({ ...edits, [c.user_id]: v })} />
								</li>
							);
						})}
					</ul>
					<div className="co-acc">
						<button className="av-btn pri" disabled={!elegidos.length || hayMalas} onClick={crear}>Crear {elegidos.length} Buzones</button>
						<button className="av-btn" onClick={cerrar}>Cancelar</button>
					</div>
				</>
			) : (
				<>
					<div className="av-tenue">{fase === "creando" ? "Creando… " : "Listo. "}{hechos} de {elegidos.length} creados{fallas.length ? " · " + fallas.length + " con problema" : ""}.</div>
					<div className="co-barra"><i style={{ width: Math.round((100 * (hechos + fallas.length)) / Math.max(1, elegidos.length)) + "%" }} /></div>
					{fallas.length ? <ul className="co-filas">{fallas.map((f, i) => <li key={i} className="co-fila"><span className="co-nom"><b>{f.email}</b><small>{f.error}</small></span></li>)}</ul> : null}
					{fase === "listo" ? <div className="co-acc"><button className="av-btn pri" onClick={cerrar}>Cerrar</button></div> : null}
				</>
			)}
		</section>
	);
};

const Detalle: React.FC<{ b: Buzon; ocupado: string | null; hacer: (k: string, fn: () => Promise<any>, msg?: string) => void; setError: (s: string | null) => void }> = ({ b, ocupado, hacer, setError }) => {
	const [clave, setClave] = useState<string | null>(null);
	const [ajustes, setAjustes] = useState(false);
	const [manual, setManual] = useState<AjustesManuales | null>(null);
	const [bit, setBit] = useState<BitacoraFila[] | null>(null);
	const [copiado, setCopiado] = useState(false);
	const activo = b.estado === "activo";

	const pedirClave = async (renovar: boolean) => {
		if (renovar && !window.confirm("¿Generar una contraseña nueva? La anterior deja de funcionar en todos los aparatos de " + (b.nombre || b.email) + ".")) return;
		setError(null);
		try { setClave((await correoApi.clave(b.id, renovar)).data.clave); setCopiado(false); } catch (e) { setError(errorTexto(e)); }
	};
	const perfil = async () => {
		setError(null);
		try {
			const r = await correoApi.perfilUrl(b.id);
			setManual(r.data.manual);
			const a = document.createElement("a");
			a.href = r.data.url; a.download = "correo-washington-academy.mobileconfig";
			document.body.appendChild(a); a.click(); a.remove();
		} catch (e) { setError(errorTexto(e)); }
	};
	const verManual = async () => {
		if (manual) { setManual(null); return; }
		try { setManual((await correoApi.perfilUrl(b.id)).data.manual); } catch (e) { setError(errorTexto(e)); }
	};
	const verBit = async () => {
		if (bit) { setBit(null); return; }
		try { setBit((await correoApi.bitacora(b.id)).data.bitacora); } catch (e) { setError(errorTexto(e)); }
	};
	const copiar = () => { try { navigator.clipboard.writeText(clave || ""); setCopiado(true); } catch (e) { /* sin portapapeles */ } };

	return (
		<div className="co-det">
			{ajustes ? <AjustesCorreo buzonId={b.id} titulo={(b.nombre || "") + " · " + b.email} esSuper alCerrar={() => setAjustes(false)} /> : null}
			{b.detalle ? <div className="av-aviso oro co-sinclic">{b.detalle}</div> : null}
			{b.habilitada === false && activo ? <div className="av-aviso oro co-sinclic">Esta persona está desactivada en WAPP pero su buzón sigue activo.</div> : null}
			<div className="av-acciones">
				{activo ? <button className="av-btn" disabled={!!ocupado} onClick={() => { if (window.confirm("¿Suspender el buzón de " + (b.nombre || b.email) + "? No podrá entrar ni recibir correo.")) hacer("s" + b.id, () => correoApi.suspender(b.id), "Buzón suspendido."); }}>Suspender</button> : null}
				{b.estado === "suspendido" || b.estado === "error" || b.estado === "pendiente" ? <button className="av-btn pri" disabled={!!ocupado} onClick={() => hacer("r" + b.id, () => correoApi.reactivar(b.id), "Buzón reactivado.")}>Reactivar</button> : null}
				{activo ? <button className="av-btn" onClick={() => pedirClave(false)}>Contraseña del Celular</button> : null}
				{activo ? <button className="av-btn" onClick={perfil}>Configurar en iPhone / Mac</button> : null}
				<button className="av-btn" onClick={verManual}>{manual ? "Ocultar Datos" : "Apple Mail / Android / Outlook"}</button>
				<button className="av-btn" onClick={() => setAjustes(true)}>Ajustes del Correo</button>
				<button className="av-btn" onClick={verBit}>{bit ? "Ocultar Bitácora" : "Bitácora"}</button>
			</div>

			{clave ? (
				<div className="co-clave">
					<span className="av-etq">Contraseña del Celular</span>
					<code>{clave}</code>
					<button className="av-btn chico" onClick={copiar}>{copiado ? "Copiada" : "Copiar"}</button>
					<button className="av-btn chico" onClick={() => pedirClave(true)}>Generar Nueva</button>
					<button className="av-x" onClick={() => setClave(null)} aria-label="Ocultar">×</button>
				</div>
			) : null}
			{!clave && activo && !b.con_clave ? <div className="av-tenue co-sinclic">Este buzón no tiene contraseña de WAPP: usa "Contraseña del Celular" y genera una nueva.</div> : null}

			{manual ? (
				<div className="co-manual">
					<h3>Apple Mail (iPhone, iPad, Mac)</h3>
					<ol>
						<li>Lo más fácil: <b>Configurar en iPhone / Mac</b> baja un perfil. Ábrelo y acéptalo en Ajustes › General › VPN y Gestión de Dispositivos (en Mac: Ajustes del Sistema › Privacidad y Seguridad › Perfiles). Pide la contraseña del celular.</li>
						<li>A mano en iPhone: Ajustes › Apps › Mail › Cuentas › Añadir Cuenta › Otra › Añadir Cuenta de Correo. En Mac: Mail › Añadir Cuenta › Otra Cuenta de Mail.</li>
						<li>Nombre, correo <b>{manual.usuario}</b> y la contraseña del celular; elige <b>IMAP</b> y usa los mismos servidores de abajo.</li>
					</ol>
					<h3>Configurar a Mano (Android, Outlook, Gmail)</h3>
					<ol>
						<li>Agrega una cuenta nueva de tipo <b>IMAP</b> (no Gmail ni Outlook.com).</li>
						<li>Usuario: <b>{manual.usuario}</b> · Contraseña: la "contraseña del celular" (no la de WAPP).</li>
						<li>Entrante: <b>{manual.imap.host}</b>, puerto <b>{manual.imap.puerto}</b>, {manual.imap.seguridad}.</li>
						<li>Saliente: <b>{manual.smtp.host}</b>, puerto <b>{manual.smtp.puerto}</b>, {manual.smtp.seguridad}, con el mismo usuario y contraseña.</li>
					</ol>
				</div>
			) : null}

			{bit ? (
				<ul className="co-bit">
					{bit.length === 0 ? <li className="av-tenue">Sin movimientos.</li> : bit.map((x, i) => (
						<li key={i}><b>{x.accion}</b> <span>{x.detalle || ""}</span><small>{fechaHora(x.created_at)}{x.actor ? " · " + x.actor : ""}</small></li>
					))}
				</ul>
			) : null}
			<div className="av-tenue co-pie">Última consulta a Migadu: {fechaHora(b.migadu_at)}{b.clave_at ? " · Contraseña del celular de " + fechaHora(b.clave_at) : ""}</div>
		</div>
	);
};

export default Buzones;
